import { render } from "./audited.vue?vue&type=template&id=c530c7fa&scoped=true"
import script from "./audited.vue?vue&type=script&lang=js"
export * from "./audited.vue?vue&type=script&lang=js"

import "./audited.vue?vue&type=style&index=0&id=c530c7fa&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c530c7fa"]])

export default __exports__